const getConfig = () => {
  const ENV = process.env.TARGET_ENV;
  const config = {
    production: {
      APP_URL: "https://app.uncody.com",
      WEB_URL: "https://uncody.com",
      RECAPTCHA_SITE_KEY: "6Ld8K9stAAAAAA622cQOvkYBtZVMCircpYpYMBeW",
      UNCODY_CUSTOMER_WEB_DOMAIN:'.uncody.site',
    },
    development: {
      APP_URL: "http://app.uncodylocal.com:3001",
      WEB_URL: "http://uncodylocal.com:3001",
      RECAPTCHA_SITE_KEY: "6Ld8K9stAAAAAA622cQOvkYBtZVMCircpYpYMBeW",
      UNCODY_CUSTOMER_WEB_DOMAIN:'.uncody.site',
    },
    dev: {
      APP_URL: process.env.REACT_APP_APP_URL,
      WEB_URL: process.env.REACT_APP_WEB_URL,
      RECAPTCHA_SITE_KEY: "6Ld8K9stAAAAAA622cQOvkYBtZVMCircpYpYMBeW",
      UNCODY_CUSTOMER_WEB_DOMAIN:'.publish.onuncody.online',
    },
  };
  return config[ENV];
};

export const config = getConfig();